import { CircularProgress } from "@mui/material";
import { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";



export const LoaderContext = createContext()


export function LoaderComponent({ isLoading, children }) {

    if (!isLoading) {
        return (children)
    } else {
        return (
            <div
                style={{ height: "100vh" }}
                className="d-flex align-items-center justify-content-center"
            >
                <CircularProgress color="primary" size={80} />
            </div>
        )
    }
}

export default function Loader({ children }) {
    const [isLoading, setisLoading] = useState(false)
    const location = useLocation()

    useEffect(()=>{
        
        window.scrollTo(0, 0)
    },[location])

    useEffect(() => {

        if (isLoading) {
            window.scrollTo(0, 0)
            document.body.style.overflow = "hidden"
        } else {
            document.body.style.overflow = "auto"
        }
    }, [isLoading])


    return (
        < LoaderContext.Provider value={{ isLoading, setisLoading }}>
            {isLoading &&
                <>
                    <div style={{ height: "100vh", position: "fixed", transformStyle: "flat", zIndex: 10000, backgroundColor: "#fff", top: 0, left: 0, right: 0 }} className="scene w-100">
                        <div className="plane">
                            <div className="cube cube--0">
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                            </div>
                            <div className="shadow shadow--0"></div>
                            <div className="cube cube--1">
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                            </div>
                            <div className="shadow shadow--1"></div>
                            <div className="cube cube--2">
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                            </div>
                            <div className="shadow shadow--2"></div>
                            <div className="cube cube--3">
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                            </div>
                            <div className="shadow shadow--3"></div>
                            <div className="cube cube--4">
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                            </div>
                            <div className="shadow shadow--4"></div>
                            <div className="cube cube--5">
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                            </div>
                            <div className="shadow shadow--5"></div>
                            <div className="cube cube--6">
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                            </div>
                            <div className="shadow shadow--6"></div>
                            <div className="cube cube--7">
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                                <div className="cube__side"></div>
                            </div>
                            <div className="shadow shadow--7"></div>
                        </div>
                    </div>
                </>
            }

            {children}

        </LoaderContext.Provider >
    )
}